import { fmtIDR } from "./api";

const VERB = {
  create: "membuat", update: "memperbarui", delete: "menghapus", cancel: "membatalkan",
  cancelled: "membatalkan", approve: "menyetujui", reject: "menolak", submit: "mengajukan",
  transfer: "memproses", adjust: "menyesuaikan", apply: "menerapkan", transition: "mengubah status",
  update_routing: "memperbarui routing", start: "memulai", login: "masuk ke", logout: "keluar dari",
  pay: "mencatat pembayaran", settle: "menyelesaikan",
};

const ENTITY = {
  keep: "Keep", sales: "Penjualan", sale: "Penjualan", payment: "Pembayaran",
  purchase_order: "Purchase Order", transfer: "Transfer Stok", customer: "Customer",
  customer_group: "Group Customer", product: "Produk", role: "Role", user: "User",
  mp_settlement: "Settlement Marketplace", opname: "Stock Opname", settings: "Pengaturan",
  migration: "Migrasi", production_plan: "Rencana Produksi", supplier: "Supplier",
  material: "Material", bom: "BOM", cutting: "Cutting", receiving: "Penerimaan",
  stock: "Stok", role_permission: "Hak Akses",
};

const cap = (s) => (s ? s.charAt(0).toUpperCase() + s.slice(1) : s);

export function describeActivity(a) {
  const d = a.details || {};
  const verb = VERB[a.action] || a.action || "melakukan aksi pada";
  const label = ENTITY[a.entity] || a.entity || "data";
  const ref = d.number || d.name || d.order_id || d.filename || d.email || d.title || "";
  let s = `${cap(verb)} ${label}${ref ? ` ${ref}` : ""}`;
  const extra = [];
  if (d.customer_name) extra.push(`customer ${d.customer_name}`);
  if (d.status) extra.push(`status ${d.status}`);
  if (d.to) extra.push(`menjadi ${d.to}`);
  if (d.grand_total != null) extra.push(`senilai ${fmtIDR(d.grand_total)}`);
  if (d.amount != null) extra.push(`sebesar ${fmtIDR(d.amount)}`);
  if (d.method || d.payment_method) extra.push(`via ${d.method || d.payment_method}`);
  if (d.rows != null) extra.push(`${d.rows} baris`);
  if (d.count != null) extra.push(`${d.count} item`);
  if (d.role) extra.push(`role ${d.role}`);
  if (d.adjusted != null) extra.push(`${d.adjusted} penyesuaian`);
  if (extra.length) s += ` — ${extra.join(", ")}`;
  return s;
}
